import type { ChatHistory } from 'types/chatbot';
import { upsertChatHistory } from 'utils/chatbotHistory';
import type { ChatbotState } from '../index';

export const saveConversation = (state: ChatbotState, { payload }: { payload: ChatHistory }) => {
  state.history = upsertChatHistory(state.history, payload);
  state.activeHistoryId = payload.id;
};
